<template>
    <div class="subscription-competition-view flex-between-wrapper">
        <div class="premium-competition-view">
          <h3 class="view-title">Motivate students to reach their full potential.</h3>
          <p class="view-description">With Premium you can deeply engage students with classroom competitions, badges, prizes, and more! Bonus - students can track their own progress and have agency over their achievements.</p>
          <div class="button-wrapper">
            <primary-button @click="handleClickPlan">Choose your plan</primary-button>
          </div>
        </div>
        <img class="feature-image" src="/assets/app/class/competition-frame-bg.png">
    </div>
</template>

<script>

import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    PrimaryButton
  },
  methods: {
    handleClickPlan() {
      this.$emit('showPlan');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-competition-view {
  .premium-competition-view {
    max-width: 375px;
    margin-right: 10px;
  }
  .feature-image {
    margin-top: -20px;
  }
  @media(max-width: 900px) {
    display: block;
    .premium-competition-view {
      max-width: none;
      margin: 0;
    }
    .feature-image {
      margin-top: 0;
    }
  }
}
</style>
